import { defineStore } from 'pinia';

export interface ICountry {
  name: string;
  code: string;
  icon: string;
  phonePrefix: string;
}

export enum AuthorizationTab {
  LOGIN = 'login',
  REGISTER = 'register',
}

export const useAuthorizationStore = defineStore('authorization', () => {
  const { getContent } = useProjectMethods();
  const { popupsData, defaultLocalePopupsData } = storeToRefs(useGlobalStore());

  const countryDetails = ref<ICountry[]>([]);
  const countryOrigin = ref('');
  const currentAuthorizationTab = ref<AuthorizationTab>(AuthorizationTab.LOGIN);

  const { getInitUserInfo } = useCoreGlobalApi();
  const { countries } = storeToRefs(useGlobalStore());
  const { iconUrl: iconFlags } = useDynamicIcon('flags');

  const authorizationTabs = computed(() => {
    return [
      {
        id: AuthorizationTab.LOGIN,
        name: getContent(popupsData.value, defaultLocalePopupsData.value, 'authorization.login'),
        disabled: false,
      },
      {
        id: AuthorizationTab.REGISTER,
        name: getContent(popupsData.value, defaultLocalePopupsData.value, 'authorization.register'),
        disabled: false,
      },
    ];
  });

  const setAuthorizationTab = (tab: AuthorizationTab) => {
    currentAuthorizationTab.value = tab;
  };

  const initializeInfo = async () => {
    if (countryDetails.value.length) {
      return;
    }

    try {
      const origin = await getInitUserInfo();

      countryDetails.value = countries.value.map(el => ({
        name: el.name,
        code: el.code,
        icon: `${iconFlags.value}/${el.code.toLowerCase()}.svg`,
        phonePrefix: el.phonePrefix,
      }));

      countryOrigin.value = origin.country;
    } catch (e) {
      console.error('Failed to init country data', e);
    }
  };

  return {
    countryDetails,
    countryOrigin,
    currentAuthorizationTab,
    authorizationTabs,
    initializeInfo,
    setAuthorizationTab,
  };
});
